import Slider from 'react-slick';
import styled from 'styled-components';

export const Wrapper = styled(Slider)`
  width: auto;
  height: auto;
  text-align: center;

  ${({ theme }) => theme.media.pc} {
    width: 210px;
    height: 358px;
  }

  .side-slider {
    width: 100%;
    text-align: center;
    position: absolute;
    padding: 0;
    bottom: 18px;
  }

  .side-slider li:not(:last-child) {
    margin-right: 7px;
  }
  .side-slider li {
    position: relative;
    display: inline-block;
    cursor: pointer;
    padding: 0;
  }

  .side-slider li button {
    display: block;
    line-height: 0;
    padding: 0;
    cursor: pointer;
    color: transparent;
    border: 0;
    outline: 0;
    background: 0 0;
  }

  .side-slider li button:before {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 8px;
    height: 8px;
    text-align: center;
    background: #c4c4c4;
    border-radius: 50px;
  }

  .side-slider li.slick-active {
    width: 42px;
  }

  .side-slider li.slick-active button:before {
    background: #666;
    width: 42px;
  }
`;

export const Title = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  font-size: ${({ theme }) => theme.fontSize.T1};
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.gray900};
`;

export const SubTitle = styled.p`
  white-space: pre-wrap;
  font-weight: ${({ theme }) => theme.fontWeight.normal};
  font-size: ${({ theme }) => theme.fontSize.B3};
`;

export const SideBannerWrapper = styled.a<{ background: string }>`
  cursor: pointer;
  display: inline-block;
  line-height: 1.5;
  border-radius: 4px;
  background: ${(props) => props.background};
  height: 305px;
  display: block;
  text-decoration: none;

  width: 210px;
  height: 358px;
  text-align: left;
  padding: 30px 0 18px 0;

  & ${Title} {
    margin-bottom: 4px;
    padding: 0 20px;
  }

  & ${SubTitle} {
    margin-bottom: 18px;
    padding: 0 20px;
  }

  & img {
    width: 208px;
    height: 185px;
  }

  ${({ theme }) => theme.media.with('tablet', 'mobile')} {
    width: auto;
    height: 305px;
    text-align: center;

    & > ${SubTitle} {
      margin-bottom: 5px;
    }

    & > img {
      width: 168px;
      height: 150px;
      margin: auto;
    }
  }
`;
